import { useEffect } from 'react'
/**
 * A custom React hook that runs a callback function when the component is mounted and unmounted.
 * It uses the useEffect hook with an empty dependency array, ensuring that the callback is only executed once
 * when the component is mounted and cleaned up when the component is unmounted.
 *
 * @param callback - The function to be executed on mount and unmount. It can return a cleanup function.
 */
export default function useMountEffect(callback: () => void | (() => void)) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(callback, [])
}
